function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ArcadeOverlayTemplate = require('./arcade_overlay.template');
var NewGameOverlay = require('./new-game');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');

/**
 * NWASM library panel opened from the Arcade Nintendo 64 Game card.
 * Owned entirely by NWASM — Arcade only invokes Game.onClick().
 */
var NwasmArcadeOverlay = /*#__PURE__*/function () {
  function NwasmArcadeOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, NwasmArcadeOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.new_game_overlay = new NewGameOverlay(app, mod);
    this.games = [];
    this.is_open = false;
    this.upload_busy = false;
  }
  return _createClass(NwasmArcadeOverlay, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.render();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open() {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.is_open) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.render();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$mod,
          _this = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && (_this$mod = _this$mod.ui) !== null && _this$mod !== void 0 && _this$mod.load_games) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return this.mod.ui.load_games();
            case 2:
              this.games = _context3.v;
              this.mod.ui.games = this.games;
              this.overlay.show(ArcadeOverlayTemplate(this.app, this.mod, this.games), function () {
                _this.is_open = false;
                _this.upload_busy = false;
              });
              this.is_open = true;
              this.upload_busy = false;
              this.attachEvents();
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "close",
    value: function close() {
      this.is_open = false;
      this.overlay.close();
    }
  }, {
    key: "openRomWizard",
    value: function openRomWizard() {
      var _this$mod2;
      var sig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!sig || !((_this$mod2 = this.mod) !== null && _this$mod2 !== void 0 && _this$mod2.openRomWizard)) {
        return;
      }
      var game = this.games.find(function (g) {
        return g.sig === sig;
      });
      this.mod.openRomWizard(sig, (game === null || game === void 0 ? void 0 : game.title) || '');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = document.querySelector('.nwasm-arcade-overlay');
      if (!root) {
        return;
      }
      root.querySelectorAll('.launch').forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          var sig = btn.getAttribute('data-sig');
          if (sig) {
            _this2.openRomWizard(sig);
          }
        };
      });
      root.querySelectorAll('.table .row').forEach(function (row) {
        row.onclick = function (e) {
          if (e.target.closest('.launch')) {
            return;
          }
          e.preventDefault();
          var sig = row.getAttribute('data-sig');
          if (sig) {
            _this2.openRomWizard(sig);
          }
        };
        row.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var sig = row.getAttribute('data-sig');
            if (sig) {
              _this2.openRomWizard(sig);
            }
          }
        };
      });
      this.attachUpload();
    }
  }, {
    key: "attachUpload",
    value: function attachUpload() {
      var _this3 = this;
      var dropzone = document.getElementById('nwasm-arcade-upload');
      if (!dropzone) {
        return;
      }
      var setBusy = function setBusy() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Uploading…';
        _this3.upload_busy = true;
        dropzone.classList.add('busy');
        var state = dropzone.querySelector('.state');
        var status = dropzone.querySelector('.status');
        var prompt = dropzone.querySelector('.prompt');
        if (state) {
          state.hidden = false;
        }
        if (status) {
          status.textContent = message;
        }
        if (prompt) {
          prompt.hidden = true;
        }
      };
      var clearBusy = function clearBusy() {
        _this3.upload_busy = false;
        dropzone.classList.remove('busy');
        var state = dropzone.querySelector('.state');
        var prompt = dropzone.querySelector('.prompt');
        if (state) {
          state.hidden = true;
        }
        if (prompt) {
          prompt.hidden = false;
        }
      };
      try {
        this.app.browser.addDragAndDropFileUploadToElement('nwasm-arcade-upload', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file, _is_drag, native_file) {
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  if (!_this3.upload_busy) {
                    _context4.n = 1;
                    break;
                  }
                  return _context4.a(2);
                case 1:
                  if (file) {
                    _context4.n = 2;
                    break;
                  }
                  alert('Unable to read that ROM file.');
                  return _context4.a(2);
                case 2:
                  setBusy('Preparing upload…');
                  _this3.mod.active_rom = file;
                  _this3.mod.uploaded_rom = false;
                  _this3.mod.active_rom_name = '';
                  _this3.new_game_overlay.render({
                    file: file,
                    file_name: (native_file === null || native_file === void 0 ? void 0 : native_file.name) || 'Selected ROM'
                  });
                  clearBusy();
                case 3:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }(), false, true);
      } catch (err) {
        console.log('Nwasm ArcadeOverlay upload error: ' + err);
        clearBusy();
      }
    }
  }]);
}();
module.exports = NwasmArcadeOverlay;